import React, { createContext, useContext, useEffect, useState } from 'react';

const FleetRequestsContext = createContext();

export const useFleetRequests = () => {
  const context = useContext(FleetRequestsContext);
  if (!context) {
    throw new Error('useFleetRequests must be used within a FleetRequestsProvider');
  }
  return context;
};

const STORAGE_KEY = 'fleetQuoteRequests';

export const FleetRequestsProvider = ({ children }) => {
  const [fleetRequests, setFleetRequests] = useState(() => {
    if (typeof window === 'undefined') return [];
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : [];
  });

  useEffect(() => {
    if (typeof window === 'undefined') return;
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(fleetRequests));
  }, [fleetRequests]);

  const submitFleetRequest = (request) => {
    const uniqueId = typeof crypto !== 'undefined' && crypto.randomUUID
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(36).slice(2, 7)}`;

    const newRequest = {
      id: uniqueId,
      createdAt: new Date().toISOString(),
      ...request
    };
    setFleetRequests(prev => [newRequest, ...prev]);
    return newRequest;
  };

  const deleteFleetRequest = (id) => {
    setFleetRequests(prev => prev.filter(req => req.id !== id));
  };

  const value = {
    fleetRequests,
    submitFleetRequest,
    deleteFleetRequest
  };

  return (
    <FleetRequestsContext.Provider value={value}>
      {children}
    </FleetRequestsContext.Provider>
  );
};
